import { ComparateurFunnel } from '../../../components/tools/ComparateurFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('agriculteurs', 'comparateur-energie')!;

export default function AgriculteursComparateurEnergiePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/agriculteurs"
        backLabel="Espace agriculteurs"
        duration="3 min"
      >
        <ComparateurFunnel lockedAudience="agriculteurs" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace agriculteurs', url: 'https://solutionecofrance.fr/agriculteurs' },
          { name: 'Comparateur énergie', url: 'https://solutionecofrance.fr/agriculteurs/comparateur-energie' },
        ]}
      />
    </>
  );
}
